import { Stack, Typography } from "@mui/material";
import React from "react";

export interface SectionHeaderQuoteProps {
	title: string;
	icon?: React.ReactElement;
}

export const SectionHeaderQuote = ({ icon, title }: SectionHeaderQuoteProps) => {
	return (
		<Stack direction="row" alignItems="center" mb={2}>
			{icon &&
				React.cloneElement(icon, {
					color: "primary",
					sx: { mr: 1 },
				})}
			<Typography variant="h6">{title}</Typography>
		</Stack>
	);
};
